import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "theme-1" }
const _hoisted_2 = { class: "tw-user-profile-card" }
const _hoisted_3 = { class: "tw-profile-identity" }
const _hoisted_4 = { class: "tw-profile-identity-text" }
const _hoisted_5 = { class: "tw-profile-name" }
const _hoisted_6 = {
  key: 0,
  class: "tw-profile-role"
}
const _hoisted_7 = { class: "tw-profile-facts" }
const _hoisted_8 = { class: "tw-profile-fact" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "tw-profile-fact" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "tw-profile-status-dot" }, null, -1)
const _hoisted_12 = { class: "tw-profile-action-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_avatar, {
          size: "44px",
          color: "amber",
          "text-color": "white",
          class: "tw-profile-avatar"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.initials), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.user.firstName + " " + _ctx.user.lastName), 1),
          (_ctx.userRole)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.userRole), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_q_icon, {
            name: "mail_outline",
            size: "16px",
            class: "tw-profile-fact-icon"
          }),
          _createElementVNode("span", {
            class: "tw-profile-fact-value",
            title: _ctx.user.email
          }, _toDisplayString(_ctx.user.email), 9, _hoisted_9)
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_q_icon, {
            name: "verified_user",
            size: "16px",
            class: "tw-profile-fact-icon"
          }),
          _createElementVNode("span", {
            class: _normalizeClass(["tw-profile-status", _ctx.user.loggedIn ? 'is-active' : 'is-inactive'])
          }, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.user.loggedIn === true
              ? _ctx.$t('party.account.statut.active')
              : _ctx.$t('garantie.garantiedetails.statuslist.Inactive')), 1)
          ], 2)
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "tw-profile-action",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.UserPreference && _ctx.UserPreference(...args)))
      }, [
        _createVNode(_component_q_icon, {
          name: "settings",
          size: "18px",
          class: "tw-profile-action-icon"
        }),
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("userPreference.userPreference")), 1),
        _createVNode(_component_q_icon, {
          name: "chevron_right",
          size: "18px",
          class: "tw-profile-action-chevron"
        })
      ])
    ])
  ]))
}